import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Switch,
  Route,
  withRouter
} from 'react-router-dom';

import Intro from '../screens/Intro';
import Question from '../screens/Question';
import NoMatch from '../screens/NoMatch';
import { Questions } from '../Data';
import ResultsForm from '../screens/ResultsForm';
import ResultsRecommendations from '../screens/ResultsRecommendations';

const firstQuestionUrl = Questions[0].url;

const QuestionList = Questions.map((key, i) => {
  key.questionNumber = i;

  return (
    <Route path={key.url} key={i} children={({ match, ...rest}) => {
      return match && <Question key={i} data={key} {...rest}/>
    }} />
  );
});

class Routes extends Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  componentDidMount() {
    // redirection to home if landed on anything but question
    if (process.env.NODE_ENV === 'production') {
      if (this.props.location.pathname !== '/') {
        this.props.history.push('/');
      }
    }
  }

  render() {

    //const { match, location, history } = this.props;

    window.historys = this.props.history;

    return (
      <Switch>
        <Route exact path='/' children={({ match, ...rest }) => {
          return match && <Intro key="1" firstQuestionUrl={firstQuestionUrl} {...rest}/>
        }} />
        {QuestionList}
        <Route path='/results' children={({ match, ...rest }) => {
          return match && <ResultsForm key="32" connectionStatus={this.props.connectionStatus} overlayMessage={this.props.overlayMessage} overlayToggle={this.props.overlayToggle} {...rest}/>
        }} />
        <Route path='/results-recommendations' children={({ match, ...rest }) => {
          return match && <ResultsRecommendations key="31" overlayMessage={this.props.overlayMessage} overlayToggle={this.props.overlayToggle} {...rest}/>
        }} />
        <Route children={({ match, ...rest }) => {
          return match && <NoMatch {...rest}/>
        }} />
      </Switch>
    );
  }
}

export default withRouter(Routes);



// WEBPACK FOOTER //
// ./src/components/Routes.js